import { handlePostAction } from "../../../utils/event-api-invoke";
import { getGrossMarginLevelAPIPostSchema, getGrossMarginLevelAuditInfoSchema } from "../edit/Schema";

let _isError = false;

const _getPreviousState = (data) => {
  try {
    let _prevState = {};

    _prevState.GMLevel = data?.GMLevel || "";
    _prevState.GrossMarginMinPercent = data?.GrossMarginMinPercent || 0;
    _prevState.GrossMarginMaxPercent = data?.GrossMarginMaxPercent || 0;

    return JSON.stringify(_prevState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const _getCurrentState = (data) => {
  try {
    let _currentState = {};

    _currentState.GMLevel = data?.GMLevel || "";
    _currentState.GrossMarginMinPercent = data?.GrossMarginMinPercent || 0;
    _currentState.GrossMarginMaxPercent = data?.GrossMarginMaxPercent || 0;
    
    return JSON.stringify(_currentState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getGrossMarginLevelAuditInfoSchema();

    _auditSchema.auditInfo[0].shortDesc = data?.GMLevel;
    _auditSchema.auditInfo[0].currentState = _getCurrentState(data);
    if (auditConfig.EditHashId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.EditHashId;
      _auditSchema.auditInfo[0].Action = "EDIT";
      _auditSchema.auditInfo[0].previousState = _getPreviousState(auditConfig.formdata); //For single tables during record deletion send data to previous state instead of form data
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {

    let _postSchema = {};
    
      _postSchema = getGrossMarginLevelAPIPostSchema(config.countryCode, config.businessCode);

      _postSchema.grossMarginLevel[0].GMLevel = data?.GMLevel || 0;
      _postSchema.grossMarginLevel[0].GrossMarginMinPercent = data?.GrossMarginMinPercent || 0;
      _postSchema.grossMarginLevel[0].GrossMarginMaxPercent = data?.GrossMarginMaxPercent || 0;

      if (config.EditHashId) {
        _postSchema.grossMarginLevel[0].HashId = config.EditHashId;
      }

    return _postSchema;

  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const saveGrossMarginLevel = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditHashId,
    settingsConfig: { businessCode, countryCode },
    formdata
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { EditHashId, formdata });
    let _postPayload = getPostPayload(data, { EditHashId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "GrossMarginLevel");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveGrossMarginLevel};
